import { createStore } from 'vuex'
import {
  loginUser,
  firstLoginUser,
  logoutUser,
  getAppversion,
  refreshTokenVerify,
} from '@/api/auth.js'

import { updatePushYn } from '@/api/mypage.js'
import { getAlarmDetail } from '@/api/alarm'
import { attendance } from '@/api/atdc'
import {
  saveTokenToStorage,
  saveUserToStorage,
  getUserFromStorage,
  getUserToken,
  getRefreshToken,
  deleteUserStorage,
  saveStateToStorage,
  deleteStateToStorage,
  getStateToStorage,
} from '@/utils/storages'
import javascriptBridge from '@/utils/javascriptBridge'
import router from '@/router/index.js'
import links from './modules/links'
import Cookies from 'js-cookie'
import { nextTick } from 'vue'

export default createStore({
  namespaced: true,
  state: {
    LoadingStatus: false,
    keepLogin: getStateToStorage('keepLogin') || false,
    userInfo: getUserFromStorage() || '',
    userToken: getUserToken() || '',
    refreshToken: getRefreshToken() || '',
    deviceOs: '',
    pushToken: '',
    pushYn: '',
    appVersion: '',
    uuid: '',
    pushData: '',
    items: [], // 라우터 이동 시 가져갈 데이터 임시 저장
    popupHidden: false, // 바텀시트 팝업 보지 않기
    userData: [],
    activeBle: false,
    attendance: 'N',
  },
  getters: {
    getAttendance(state) {
      return state.attendance
    },
    isLogin(state) {
      return state.userInfo !== ''
    },
    getUser(state) {
      return state.userInfo
    },
    getDeviceOs(state) {
      return state.deviceOs
    },
    getUserToken(state) {
      return state.userToken
    },
  },
  mutations: {
    START_SPINNER(state) {
      state.LoadingStatus = true
    },
    END_SPINNER(state) {
      state.LoadingStatus = false
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_USER_TOKEN(state, userToken) {
      state.userToken = userToken
    },
    SET_REFRESH_INFO(state, refreshToken) {
      state.refreshToken = refreshToken
    },
    FETCH_KEEP_LOGIN(state, keepLogin) {
      state.keepLogin = keepLogin
    },
    FETCH_DEIVICE_INFO(state, deviceInfo) {
      state.deviceOs = deviceInfo.deviceOs
      state.appVersion = deviceInfo.appVersion
      state.uuid = deviceInfo.uuid
    },
    FETCH_PUSH_INFO(state, pushInfo) {
      // 알림설정 변경
      state.pushYn = pushInfo.pushYn
      if (pushInfo.pushYn === 'Y') {
        state.pushToken = pushInfo.pushToken
      } else {
        state.pushToken = ''
      }
    },
    FETCH_VIEW_ITEM(state, item) {
      state.items = item
    },
    FETCH_ALARM_CATEGORY(state, alarmTab) {
      state.alarmCat = alarmTab
    },
    FETCH_POPUP_HIDDEN(state, isHidden) {
      state.popupHidden = isHidden
    },
    SET_TEMP_USER_DATA(state, userData) {
      state.userData = userData
    },
    FETCH_ACTIVE_BLE(state, yn) {
      state.activeBle = yn
    },
    FETCH_ATTENDANCE(state, val) {
      state.attendance = val
    },
  },
  actions: {
    // 모바일 기기의 디바이스 정보를 가져옴
    // deviceOs
    // appVersion
    // uuid
    async SET_ACTIVE_BLE({ commit }) {
      commit('FETCH_ACTIVE_BLE', true)
    },
    async SET_DISABLE_BLE({ commit }) {
      commit('FETCH_ACTIVE_BLE', false)
    },
    async SET_BLE_SCAN({ commit }, yn) {
      if (yn === '0') {
        try {
          const response = await attendance()
          if (response.status === 200) {
            alert('등(하)원 처리 완료')
            commit('FETCH_ACTIVE_BLE', false)
            commit('FETCH_ATTENDANCE', response.data)
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        alert('학원정보를 찾을수 없습니다.')
        commit('FETCH_ACTIVE_BLE', false)
      }
    },
    async SET_DEIVICE_INFO({ commit }, deviceInfo) {
      commit('FETCH_DEIVICE_INFO', deviceInfo)

      try {
        const response = await getAppversion(deviceInfo.deviceOs)

        if (response.status === 200) {
          // n.n 숫자로 비교
          if (deviceInfo.appVersion < response.data) {
            if (
              confirm(
                '최신버전의 앱이 아닙니다.\n최적의 사용 환경을 위해\n최신버전의 앱으로 업데이트 해 주세요.'
              )
            ) {
              const url =
                deviceInfo.deviceOs === 'ANDROID'
                  ? 'https://play.google.com/store/apps/details?id=academy.sports.piston'
                  : 'https://apps.apple.com/app/id6739140594'

              const urlInfo = {
                url: url,
                io: 'O',
                searchWord: '',
              }
              javascriptBridge.outLink(urlInfo, deviceInfo.deviceOs)
            }
          }
        }
      } catch (error) {}
    },
    // 로그인 시도
    async LOGIN({ commit, dispatch }, userData) {
      const response = await loginUser(userData)

      if (response.status === 200) {
        // SET_KEEP_LOGIN 메소드 호출
        await dispatch('SET_KEEP_LOGIN', userData.keepLogin)

        const userInfo = response.data.userInfo
        const userToken = response.data.userToken
        const refreshToken = response.data.refreshToken
        commit('SET_USER_INFO', userInfo) // store 저장
        commit('SET_USER_TOKEN', userToken)
        commit('SET_REFRESH_INFO', refreshToken)

        saveUserToStorage(response.data) // localstorage 저장
        saveStateToStorage('keepLogin', userData.keepLogin)
      } else if (response.status === 201) {
        // userData 임시 저장
        commit('SET_TEMP_USER_DATA', userData) // store 저장
        // 비밀번호 셋팅 페이지로 이동
        router.push({ name: 'init-pwd' })
      } else if (response.status === 203) {
        // 옳바르지 않은 사용자
        const errorDesc = response.data.errorDesc
        if (errorDesc.startsWith('999')) {
          const message = errorDesc.slice(3).trim() // '999' 이후의 문자열을 가져오고 앞뒤 공백 제거
          alert(message)
        } else {
          alert(response.data.errorDesc)
          // alert('로그인을 처리하는 도중 문제가 발생했습니다.\n다시 시도해주세요.');
        }
        // alert("아이디 또는 비밀번호가 잘못되었습니다.");
        router.push({ name: 'login' })
      }
      return response
    },
    async SET_PUSH_ATDC({ dispatch, commit }) {
      router.push({ name: 'atdc' })
    },
    async SET_PUSH({ dispatch, commit }) {
      router.push({ name: 'alarm' })
    },
    // 로그인 최초 처리
    async FIRST_LOGIN({ commit, dispatch }, userData) {
      const response = await firstLoginUser(userData)

      if (response.status === 200) {
        await dispatch('SET_KEEP_LOGIN', userData.keepLogin)
        const userInfo = response.data.userInfo
        const userToken = response.data.userToken
        const refreshToken = response.data.refreshToken
        commit('SET_USER_INFO', userInfo) // store 저장
        commit('SET_USER_TOKEN', userToken)
        commit('SET_REFRESH_INFO', refreshToken)

        saveStateToStorage('keepLogin', userData.keepLogin)
        saveUserToStorage(response.data) // localstorage 저장
      } else if (response.status === 203) {
        const errorDesc = response.data.errorDesc
        if (errorDesc.startsWith('999')) {
          const message = errorDesc.slice(3).trim() // '999' 이후의 문자열을 가져오고 앞뒤 공백 제거
          alert(message)
        } else {
          alert(response.data.errorDesc)
          // alert('로그인을 처리하는 도중 문제가 발생했습니다.\n다시 시도해주세요.');
        }
        // alert("아이디 또는 비밀번호가 잘못되었습니다.");
        router.push({ name: 'loginSns' })
      }
      return response
    },
    // 서버에 학번 전달
    async LOGOUT({ commit, state }) {
      await logoutUser(state.userInfo.m_id, state.uuid)

      // 모든 상태 및 스토리지 초기화를 동기적으로 처리
      commit('SET_USER_INFO', '') // null로 설정하여 객체가 아니라는 것을 명확히 함
      commit('SET_USER_TOKEN', '')
      commit('SET_REFRESH_INFO', '')

      deleteUserStorage()
      deleteStateToStorage('keepLogin')
      // 바텀시트 로컬스토리지 삭제
      localStorage.removeItem('hidePopup')

      // 스크롤 설정 초기화 (테스트)
      // document.body.classList.remove('no-scroll')

      // 상태 변경이 완료된 후 라우팅
      await router.push({ name: 'home' })
    },
    // 로딩 종료
    SET_LOADING({ commit }) {
      commit('END_SPINNER')
    },
    // pushToken, pushYn 값을 가져옴
    async SET_PUSH_INFO({ commit, state }, pushInfo) {
      // state의 uuid를 pushInfo에 추가
      const updatedPushInfo = {
        ...pushInfo,
        uuid: state.uuid,
      }

      // 수정된 pushInfo로 mutation 호출
      await commit('FETCH_PUSH_INFO', updatedPushInfo)
      // 수정된 pushInfo로 API 호출
      await updatePushYn(updatedPushInfo)
    },
    // 마이페이지 > 로그인 유지 변경
    SET_KEEP_LOGIN({ commit }, keepLogin) {
      commit('FETCH_KEEP_LOGIN', keepLogin)
      saveStateToStorage('keepLogin', keepLogin)
    },
    // 라우터 이동시 가져갈 데이터 임시 저장
    SET_VIEW_DETAIL({ commit }, item) {
      commit('FETCH_VIEW_ITEM', item)
    },
    // 앱 실행하는 동안 팝업 열지 않기
    SET_POPUP_HIDDEN({ commit }, isHidden) {
      commit('FETCH_POPUP_HIDDEN', isHidden)
    },
    // 알림카테고리 저장
    SET_ALARM_CATEGORY({ commit }, alarmTab) {
      commit('FETCH_ALARM_CATEGORY', alarmTab)
    },
    SET_ATTENDANCE({ commit }, val) {
      commit('FETCH_ATTENDANCE', val)
    },

    // 앱 외부에서 알림 확인시 호출: 일반알림
    async SET_PUSH_DETAIL({ dispatch, commit }, pushInfo) {
      const alarmData = {
        system: pushInfo.cat,
        systemId: pushInfo.catId,
      }
      try {
        const response = await getAlarmDetail(alarmData)
        if (response.status === 200) {
          dispatch('SET_ALARM_CATEGORY', response.data.pushCategory)
          dispatch('SET_VIEW_DETAIL', response.data)

          // ios사용자인 경우 노치처리
          // javascriptBridge.notchDisable();

          // router.push({ name: 'alarmDetail' });
          // 페이지 전환 후에 iOS 노치 처리를 진행
          router.push({ name: 'alarmDetail' }).then(() => {
            // 페이지가 전환된 후에 notchDisable을 호출
            nextTick(() => {
              javascriptBridge.notchDisable()
            })
          })
        } else if (response.status === 203) {
          try {
            const res = await refreshTokenVerify()
            if (res.status === 200) {
              commit('SET_USER_INFO', res.data.userInfo)
              saveUserToStorage(res.data)
              dispatch('SET_PUSH_DETAIL', pushInfo)
            } else {
              alert('로그인이 만료되었습니다.[-50]')
              dispatch('LOGOUT')
              router.push({ name: 'home' })
            }
          } catch (error) {
            console.log(error)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  modules: {
    links,
  },
})
